"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _InputLabel = require("./InputLabel");
Object.keys(_InputLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InputLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _InputLabel[key];
    }
  });
});